import ActivationComponent from '../components/activation/activation.jsx'

const Activation = () => <ActivationComponent />

export default Activation;